export default __webpack_public_path__ + "static/media/backDutyIcon.67b83a0f.svg";